import React, { useContext } from "react";
import { RenderList } from "./SummaryHeader";
import Summaryutils from "../../utils/SummaryUtils";
import _ from "lodash";
import { SummaryContext } from "../../context/SummaryContext";
import JobUtils from "../../utils/JobsUtils";
import {ListItem} from "@material-ui/core";
import "../../styles/summary.scss";
import styles from "../../styles/_export.modules.scss";
import Tooltip from "@material-ui/core/Tooltip";
import ReplayIcon from "@material-ui/icons/Replay";
import CloseIcon from '@material-ui/icons/Close';
import { Types } from "../../constants/JobActions";
import {UserContext} from "../../context/UserContext";

const getDeliveryHeadersList = (deliveryMethod, updateDel, faspexAccountMapping) => {
  const headers = Summaryutils.getHeaders({
    metadata: _.get(deliveryMethod, "metadata"),
    overrideMetadata: _.get(deliveryMethod && deliveryMethod.override, "metadata"),
    readOnlyMetadata: _.get(deliveryMethod, "readOnlyMetadata"),
    overrideReadOnlyMetadata: _.get(deliveryMethod && deliveryMethod.override, "readOnlyMetadata")
  }, updateDel);
  return JobUtils.filterS3OnlyHeaders(headers, _.get(updateDel, "account"), faspexAccountMapping);
};

const deliveryContainer = (deliveries, title, jobDeliveryTypes, job, userRole, onJobAction, faspexAccountMapping) => {
  const groupedDeliveries = _.groupBy(_.map(deliveries, delivery => ({...JobUtils.updateDelivery(delivery)})), "deliveryOption");
  const ASPERA_DELIVERIES = ["Aspera Faspex", "Aspera AoC", "Aspera P2P"];
  const FAILED_DELIVERIES = ["Failed", "Invalid", "Canceled"];
  const CAN_CANCEL = ["In Progress", "Pending", "Queued"];
  const DELIVERY_ACTION_ROLES = ["globaladmin", "superadmin", "admin", "ops"];

  const getStatusColor = (status) => {
    switch (status) {
      case "Failed":
      case "Invalid":
        return styles.colorRed;
      case "Completed":
        return styles.colorBlue;
      case "Pending":
      case "In Progress":
      case "Queued":
        return styles.colorDarkGreen;
      case "Canceled":
        return styles.colorDarkOrange;
      default:
        return styles.colorBlack;
    }
  }

  const jobActionHandler = (action, delivery) => {
    const deliveryType = _.get(delivery, "deliveryOption") === 'Aspera AoC' ? 'Aspera Faspex' : _.get(delivery, "deliveryOption");
    let data = {
      requestId: _.get(job, "jobId"),
      deliveryType: deliveryType,
      accountName: _.get(delivery, "account"),
    }
    onJobAction(action, data);
  }

  return (
      <div
          className="summaryBox"
          id={"summary_container_" + title}>
        <div className="summaryTitleContainer">
          <label className="summaryHeaderTitle">
            {title}
          </label>
        </div>
        {_.map(groupedDeliveries, (del, delName) => {
          return (
              <React.Fragment key={"deliveries_list_" + delName}>
                <ListItem className="p-0 my-1 summaryFieldsLabel"
                          style={{ color: "rgb(118, 221, 251)"}}
                          key={"deliveryListItem" + delName}>
                  {Summaryutils.getDeliveryLabel({ deliveryOption: delName })}
                </ListItem>
                {_.map(del, (updateDel, index) => {
                  // This is not the nice way of doing it but doing as lable is part of the
                  // delivery and value exists in the processing. Either we make this as part of the domain
                  // model. We will revisit it later.
                  if (_.get(updateDel, "deliveryOption") === 'Screeners.com') {
                    updateDel.episodeCliptitle = _.get(job && job.processor, "outputFilename");
                  }
                  const deliveryMethod = _.find(jobDeliveryTypes, (delivery) => {
                    return (
                        _.camelCase(_.get(delivery, "label")) === _.camelCase(_.get(updateDel, "deliveryOption"))
                    );
                  });

                  return (
                      <React.Fragment key={"deliveries" + delName + index}>
                        {(_.includes(DELIVERY_ACTION_ROLES, userRole)
                            && _.includes(FAILED_DELIVERIES, _.get(updateDel, "status"))
                            && _.includes(ASPERA_DELIVERIES, _.get(updateDel, "deliveryOption"))) ? (
                            <Tooltip title="Retry Failed Delivery">
                              <ReplayIcon
                                  className="retryIcon"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    jobActionHandler(Types.RETRY, updateDel);
                                  }}
                              />
                            </Tooltip>
                        ) : null }
                        {(_.includes(DELIVERY_ACTION_ROLES, userRole)
                            && _.includes(CAN_CANCEL, _.get(updateDel, "status"))
                            && _.get(updateDel, "deliveryOption") === "Aspera P2P") ? (
                            <Tooltip title="Cancel Delivery">
                              <CloseIcon
                                  className="cancelIcon"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    jobActionHandler(Types.CANCEL, updateDel);
                                  }}
                              />
                            </Tooltip>
                        ) : null }
                      <RenderList
                        headersList={getDeliveryHeadersList(deliveryMethod, updateDel, faspexAccountMapping)}
                        data={updateDel}
                        title="delivery_view"
                        index={index}
                      />
                        {_.includes(ASPERA_DELIVERIES, _.get(updateDel, "deliveryOption")) ? (
                            <>
                              <div className="summaryFieldsDiv">
                                <label className="summaryFieldsLabel">
                                  {"Status :  "}
                                </label>
                                <div className="summaryFieldsInfo"
                                     style={{ color: getStatusColor(_.get(updateDel, "status")) }}>
                                  {_.get(updateDel, "status")}
                                </div>
                              </div>
                            </>
                        ) : null}
                      </React.Fragment>
                  )
                })}
              </React.Fragment>
          );
        })}
      </div>
  );
};

const DeliverySummary = () => {
  const { job, onJobAction } = useContext(SummaryContext);
  const { userRole, faspexAccountMapping } = useContext(UserContext);
  return _.isEmpty(job) || !_.has(job, "delivery") ? null
      : deliveryContainer(_.get(job, "delivery"),
          "Delivery", JobUtils.getJobSpecificDeliveryTypes(_.get(job, "jobType")),
          job,
          userRole,
          onJobAction,
          faspexAccountMapping);
};

export default DeliverySummary;
